"use client";

import { c as _c } from "react/compiler-runtime";
import { Separator, SideSheetBody, SideSheetHeader, SideSheetHeaderTitle, UnstyledButton } from "@opensea/ui-kit";
import { ExpandMore } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { SmartContractWalletWarningModal } from "../../../components/SmartContractWalletWarningModal";
import { useSmartContractWalletWarningModal } from "../../../components/SmartContractWalletWarningModal/use-smart-contract-warning-modal";
import { FlowActions } from "../../../stores/flowStore";
import { MoonPayCheckoutWidget } from "./MoonPayCheckoutWidget";
export const FiatCheckoutFlowContent = t0 => {
  const $ = _c(26);
  const {
    item,
    listingId,
    onBack,
    onTransactionCreated
  } = t0;
  const t = useTranslations("wallet.FiatCheckoutFlowContent");
  let t1;
  if ($[0] !== item.chain.identifier) {
    t1 = {
      destinationChain: item.chain.identifier
    };
    $[0] = item.chain.identifier;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    smartContractWalletWarningModalOpen,
    setSmartContractWalletWarningModalOpen
  } = useSmartContractWalletWarningModal(t1);
  let t2;
  if ($[2] !== onBack) {
    t2 = onBack && <UnstyledButton onClick={onBack}><ExpandMore className="rotate-90" size={24} title="Back" /></UnstyledButton>;
    $[2] = onBack;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("title");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <SideSheetHeaderTitle>{t3}</SideSheetHeaderTitle>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <SideSheetHeader className="gap-4">{t2}{t4}</SideSheetHeader>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== item || $[13] !== listingId || $[14] !== onTransactionCreated) {
    t7 = <SideSheetBody className="flex grow flex-col items-center justify-center py-6"><MoonPayCheckoutWidget item={item} listingId={listingId} onTransactionCreated={onTransactionCreated} /></SideSheetBody>;
    $[12] = item;
    $[13] = listingId;
    $[14] = onTransactionCreated;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = onBack ?? FlowActions.endFlow;
  let t9;
  if ($[16] !== setSmartContractWalletWarningModalOpen) {
    t9 = () => setSmartContractWalletWarningModalOpen(false);
    $[16] = setSmartContractWalletWarningModalOpen;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== smartContractWalletWarningModalOpen || $[19] !== t8 || $[20] !== t9) {
    t10 = <SmartContractWalletWarningModal onCancel={t8} onContinue={t9} open={smartContractWalletWarningModalOpen} />;
    $[18] = smartContractWalletWarningModalOpen;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t5 || $[24] !== t7) {
    t11 = <>{t5}{t6}{t7}{t10}</>;
    $[22] = t10;
    $[23] = t5;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};